export const UI_SCALE_DEFAULT = 100;
export const UI_SCALE_MIN = 50;
export const UI_SCALE_MAX = 200;
export const UI_SCALE_STEP_SMALL = 10;
const UI_SCALE_FACTOR_DIVISOR = 100;

export const clampUiScale = (value: number): number => {
  if (!Number.isFinite(value)) {
    return UI_SCALE_DEFAULT;
  }
  const rounded = Math.round(value);
  return Math.min(UI_SCALE_MAX, Math.max(UI_SCALE_MIN, rounded));
};

export const resolveUiScale = (value?: number | null): number =>
  clampUiScale(value ?? UI_SCALE_DEFAULT);

export const getUiScaleStep = (
  _current: number,
  _direction: "increase" | "decrease"
): number => {
  return UI_SCALE_STEP_SMALL;
};

export const adjustUiScale = (
  current: number,
  direction: "increase" | "decrease"
): number => {
  const step = getUiScaleStep(current, direction);
  const next = direction === "increase" ? current + step : current - step;
  return clampUiScale(next);
};

export const toUiScaleFactor = (value: number): number =>
  clampUiScale(value) / UI_SCALE_FACTOR_DIVISOR;
